import { createLazyComponent, LazyAction, type LazyComponent, LazyModule, registerLazyOrchestrator, } from "owa-bundling";
import type { AccountLinkProps } from "./components/AccountLinkSection";
import type * as lazyIndex from "./lazyIndex";
import { getAccountLinkStore } from "./store/store";
import { onCoprincipalBootStateChanged } from "owa-account-source-list-store";
import { accountAddedFromAccountConfigDialog, accountConfigDialogClosed } from "owa-account-config";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "OwaCloudCacheLink" */ "./lazyIndex"), { name: "OwaCloudCacheLink" });

export const AccountLinkSection: LazyComponent<AccountLinkProps, unknown, void> = createLazyComponent(lazyModule, m => m.AccountLinkSection);

export const AccountLinkingAutoOpenDialogs: LazyComponent<unknown, unknown, void> = createLazyComponent(lazyModule, m => m.AccountLinkingAutoOpenDialogs, undefined, undefined, {
    onlyImportIf: () => {
        const store = getAccountLinkStore();
        return !!store.accountToLink || !!store.accountToSignIn;
    },
});

export const lazyInitializeCloudCacheLinkStore: LazyAction<typeof lazyIndex.initializeCloudCacheLinkStore, typeof lazyModule> = new LazyAction(lazyModule, m => m.initializeCloudCacheLinkStore);

export const lazyInitializeCloudCacheLinkStoreAndDialog: LazyAction<typeof lazyIndex.initializeCloudCacheLinkStoreAndDialog, typeof lazyModule> = new LazyAction(lazyModule, m => m.initializeCloudCacheLinkStoreAndDialog);

registerLazyOrchestrator(onCoprincipalBootStateChanged, lazyModule, m => m.onCoprincipalAccountAddedOrchestrator);

registerLazyOrchestrator(accountAddedFromAccountConfigDialog, lazyModule, m => m.onAccountAddedFromAccountConfigDialogOrchestrator);

registerLazyOrchestrator(accountConfigDialogClosed, lazyModule, m => m.onAccountConfigDialogClosedOrchestrator);
